import ProductSearchListResult from './search/ProductSearchListResult';
import ProductMixAndMatch from './mix-and-match/ProductMixAndMatch';
import ProductsComparison from './comparison/ProductsComparison';
import ProductSearchGroupsResult from './search/ProductSearchGroupsResult';
import ProductDetail from './product-detail/ProductDetail';
import FeatureProductMultiVariantAddToCart from './multi-variant-add-to-cart/FeatureProductMultiVariantAddToCart';
import SearchByImageSelector from './SearchByImageSelector';

const MainFeature = () => {
    return (
        <>
            <ProductSearchGroupsResult />
            <SearchByImageSelector />
            <ProductSearchListResult />
            <ProductsComparison />
            <ProductMixAndMatch />
            <ProductDetail />
            <FeatureProductMultiVariantAddToCart />
        </>
    );
};

export default MainFeature;
